import validate from "/home/forge/dreamjobs.hu/node_modules/nuxt/dist/pages/runtime/validate.mjs";
import checkdevmode_45global from "/home/forge/dreamjobs.hu/middleware/checkdevmode.global.ts";
import main_45global from "/home/forge/dreamjobs.hu/middleware/main.global.ts";
export const globalMiddleware = [
  validate,
  checkdevmode_45global,
  main_45global
]
export const namedMiddleware = {
  auth: () => import("/home/forge/dreamjobs.hu/middleware/auth.ts"),
  candidate: () => import("/home/forge/dreamjobs.hu/middleware/candidate.ts"),
  "salary-calculator-route": () => import("/home/forge/dreamjobs.hu/middleware/salary-calculator-route.ts")
}